import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import TableInformation from 'src/components/quotations/printQuote/TableInformation';
import TableQuotation from 'src/components/quotations/printQuote/TableQuotation';
import { FieldTableType } from 'src/components/common/table/TypeCustom';
import TablePaymentInfo from './printQuote/TablePaymentInfo';
import { useEffect, useState } from 'react';
import { getField, formatQuotaionNumber } from 'src/common/helper';
import { repairDataTable } from 'src/components/quotations/QuotationService';

const border = '1px solid #0000001f';
const groupBox = {
  border: border,
  borderRadius: '4px',
};
const fontText = {
  fontSize: '14px',
  fontWeight: '500',
  lineHeight: '14.4px',
};

type DialogDetailProps = {
  detailData: any;
  selected: any;
};

const paymentInfo = [
  {
    label: '現金払い ',
    content: '手術予約日の1ヶ月前までに、上記口座へお振込み下さい。',
  },
  {
    label: '各種クレジットカード　',
    content: 'ご本人様名義のカードで事前にご利用限度額をお調べ下さい。',
  },
  {
    label: '',
    content: 'VISA、Master、JCB、American Express、Diners Club、Discover ',
  },
  {
    label: '',
    content: '1回払いのみご利用可能です。',
  },
  {
    label: '',
    content: 'ご署名は不可で、暗証番号のみご利用いただけます。'
  },
  {
    label: 'その他お支払い',
    content: 'iD、交通系電子マネー、QUICPAY、UnionPay（銀聯）',
  },
  {
    label: '医療ローン（３回～８４回）',
    content: '事前にローン会社の審査が必要です。',
  },
  {
    label: '',
    content: '審査の際には現住所の確認できる身分証明書（免許書・保険証）',
  },
  {
    label: '',
    content: '銀行の通帳またはキャッシュカード（支店名、口座番号）',
  },
  {
    label:
      '※医療品、サプリメントや薬剤はいかなる理由におきましても返品および交換はお受けできかねます。',
    content: '',
  },
  {
    label: '※ご不明な点、ご質問等ございましたらお気軽にお問い合わせ下さい。',
    content: '',
  },
];

const PrintQuote: React.FC<DialogDetailProps> = (props) => {
  const [information, setInformation] = useState<any[]>([]);
  const [dataTable, setDataTable] = useState<any[]>([]);
  const [fields, setFields] = useState<FieldTableType[]>([]);

  const getInformation = () => {
    if (props.detailData) {
      const row1 = {
        label:
          getField(props.detailData, 'patientname', '-') +
          `(${getField(props.detailData, 'patientno', '-')})`,
        content: `発行日: ${getField(props.detailData, 'quotedate', '-')}`,
      };

      const row2 = {
        label: `医師: ${getField(props.detailData, 'doctor', '-')}`,
        content: `見積番号：${formatQuotaionNumber(
          getField(props.detailData, 'id', '0')
        )}`,
      };

      setInformation((prevState: any) => [...prevState, row1, row2]);
    }
  };

  useEffect(() => {
    setInformation([]);
    getInformation();
    const quoteData = repairDataTable(props.detailData);
    setDataTable(quoteData.dataRepair);
    // eslint-disable-next-line
  }, [props.detailData]);

  useEffect(() => {
    let fieldTemp: FieldTableType[] = [
      {
        label: '施術名',
        field: 'treatment',
        align: 'left',
        width: '25%',
      },
      {
        label: '',
        field: 'note',
        align: 'left',
        width: 'auto',
      },
      {
        label: '数量',
        field: 'quantity',
        align: 'left',
        width: '10%',
      },
      {
        label: '通常価格',
        field: 'price',
        align: 'left',
        width: '15%',
        isPrice: true,
      },
    ];

    props.selected.map((select: any) => {
      if (select.name === '部分モニター価格') {
        const partField: FieldTableType = {
          label: '部分モニター価格',
          field: 'pricePartial',
          align: 'left',
          width: '20%',
          isPrice: true,
        };
        fieldTemp.push(partField);
      }

      if (select.name === '顔出しモニター価格') {
        const fullField: FieldTableType = {
          label: '顔出しモニター価格',
          field: 'priceFullFace',
          align: 'left',
          width: '20%',
          isPrice: true,
        };
        fieldTemp.push(fullField);
      }
      return select;
    });

    setFields(fieldTemp);

  }, [props.detailData, props.selected]);

  // const fields: FieldTableType[] = [
  //   {
  //     label: '施術名',
  //     field: 'treatment',
  //     align: 'left',
  //     width: '30%',
  //   },
  //   {
  //     label: '数量',
  //     field: 'quantity',
  //     align: 'right',
  //     width: '30%',
  //   },
  //   {
  //     label: '通常価格',
  //     field: 'price',
  //     align: 'right',
  //     width: '20%',
  //     isPrice: true
  //   },
  //   {
  //     label: 'モニター価格',
  //     field: 'priceMonitor',
  //     align: 'right',
  //     width: '20%',
  //     isPrice: true
  //   },
  // ];

  return (
    <Box
      sx={{
        width: '100%',
        '@media print': {
          p: '4mm',
        },
      }}
    >
      <Box sx={{ p: '3.96875mm' }}>
        <Stack spacing={'2.6458mm'}>
          <Box sx={{ ...groupBox, px: '3.96875mm' }}>
            <TableInformation items={information} title={'お見積書'} />
          </Box>
          <Box sx={{ ...groupBox }}>
            <TableQuotation items={dataTable} fields={fields} />
          </Box>
          <Box sx={{ px: '3.96875mm' }}>
            <Typography
              component={'div'}
              sx={{
                ...fontText,
                lineHeight: '1.5',
              }}
            >
              {getField(props.detailData, 'note', '')}
            </Typography>
          </Box>
          <Box sx={{ ...groupBox, p: '2.6458mm 3.96875mm' }}>
            <Box display={'flex'} justifyContent={'space-between'}>
              <Box
                sx={{
                  '& .MuiTypography-root': { ...fontText, lineHeight: '1.5' },
                }}
              >
                <Typography>{'<振込口座>'}</Typography>
                <Typography>{'三菱ＵＦＪ銀行　　0005'}</Typography>
                <Typography>{'江坂支店　074'}</Typography>
                <Typography>{'普通　0430121'}</Typography>
                <Typography>
                  {'シヤ）ニホンビヨウイリヨウケンキユウキコウ'}
                </Typography>
              </Box>
              <Box
                sx={{
                  alignContent: 'center',
                  '& .MuiTypography-root': { ...fontText, lineHeight: '1.5' },
                }}
              >
                <Typography>{'リゾナスフェイスクリニック東京'}</Typography>
                <Typography>{'メール  reserveTOKYO@resonusfc.com'}</Typography>
                <Typography>
                  {`受付担当: ${getField(props.detailData, 'fullname', '')}`}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box>
            <Box display={'flex'} justifyContent={'center'}>
              <Typography sx={{ ...fontText }}>{'◆お支払い方法◆'}</Typography>
            </Box>
          </Box>
          <Box sx={{ ...groupBox, p: '2.6458mm 3.96875mm' }}>
            <TablePaymentInfo items={paymentInfo} />
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};

export default PrintQuote;
